import SimpleSlider from "./Slider";
import "./testimonials.css";

const testimonialsList = [
  {
    id: "1",
    name: "Prateek",
    standard: "10th batch 2023 topper",
    feedback:
      "“My journey at Saraswati Pathashala was transformative. The teachers possess a remarkable gift for demystifying the most challenging topics in Mathematics and Science, turning my apprehension into genuine curiosity. Their consistent support, combined with a structured schedule of assessments, built my confidence steadily. This nurturing environment was instrumental in my outstanding board exam results.”",
  },
  {
    id: "2",
    name: "Vijayashree",
    standard: "10th batch 2023 topper",
    feedback:
      "“I will always be thankful to the mentors at Saraswati Pathashala. Before joining, I struggled with Mathematics and Science, but their patient guidance and ability to explain things clearly completely changed my perspective. The routine of regular tests kept me on track and built a strong foundation. It was this incredible support system that empowered me to achieve a result in my boards that I am truly proud of.”",
  },
  {
    id: "3",
    name: "Rahul Nair",
    standard: "Class 9 Student",
    feedback:
      "“The physics and chemistry coaching at Saraswathi Pathashala is exceptional. the teachers explain difficult concepts with practical examples and provide excellent study material. I got amazing marks!”",
  },
  {
    id: "4",
    name: "Shubhrajotsna",
    standard: "10th batch 2023 topper",
    feedback:
      "“The structured approach at Saraswati Pathashala was key to my academic success. The faculty's clear and methodical teaching made complex concepts in Math and Science not just understandable, but manageable. The regular tests were crucial, as they ensured I was consistently prepared and identified areas for improvement. This focused strategy directly contributed to a top-performing score in my board examinations.”",
  },
  {
    id: "5",
    name: "Priya Desai",
    standard: "Parent of Class 10 Student",
    feedback:
      "“My son’s academic performance has increased exponentially since joining Saraswathi Pathashala. the regular updates and parent-teacher meetings help us stay informed about his progress. Highly Recommended !”",
  },

  {
    id: "6",
    name: "Anaveerayya Math",
    standard: "10th batch 2024 topper",
    feedback:
      "“The coaching for Physics and Chemistry at Saraswati Pathashala stands out for its emphasis on true understanding. The teachers excel at breaking down abstract theories with relatable, practical examples, which made all the difference for me. Coupled with their meticulously prepared study material, I was able to achieve a level of clarity that was directly reflected in my amazing marks, not just in the sciences but in my overall performance.”",
  },
  {
    id: "7",
    name: "Rohit",
    standard: "10th batch 2024 topper",
    feedback:
      "“Thanks to the exceptional Physics and Chemistry coaching at Saraswati Pathashala, I achieved amazing marks. The teachers simplify complex topics with practical examples and provide all the necessary study resources to excel.”",
  },
  {
    id: "8",
    name: "Manasa Margol",
    standard: "10th batch 2024 topper",
    feedback:
      "“My experience in the Physics and Chemistry classes at Saraswati Pathshala did more than just improve my science scores. The teachers' method of using real-world applications to explain complex topics honed my analytical skills. This way of thinking even helped me tackle problems more effectively in Mathematics and interpret data better in Social Studies. The superior study materials and this holistic learning approach were key to my outstanding academic results.”",
  },
];

const Testimonials = () => (
  <>
    <div id="testimonials" className="testimonials-container">
      <h2 className="testimonial-header">What Our Students Say</h2>
      <p className="testimonial-caption">
        We hear from our students and parents about their experience and success{" "}
        <br />
        stories with Saraswati Pathashala
      </p>
      <ul className="testimonial-card-container">
        <SimpleSlider testimonialsList={testimonialsList} />
      </ul>
    </div>
  </>
);

export default Testimonials;
